export const PRODUCT_VERSION = "2.6.0";
export const PRODUCT_RELEASE = "Alpha 2.6.0";
